(() => {
  'use strict';
  const q = (s, c = document) => c.querySelector(s);
  const qa = (s, c = document) => [...c.querySelectorAll(s)];

  function initDropSlider(slider) {
    if (!slider || slider.dataset.bound) return;
    slider.dataset.bound = '1';
    const slides = qa('[data-password-slide]', slider);
    if (!slides.length) return;
    const count = q('[data-password-slide-count]', slider);
    const prev = q('[data-password-slide-prev]', slider);
    const next = q('[data-password-slide-next]', slider);
    let index = 0;
    let timer = null;
    let pointerStart = null;
    const pad = (n) => String(n).padStart(2, '0');
    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const link = q('a', slide);
        if (link) link.tabIndex = active ? 0 : -1;
      });
      if (count) count.textContent = `${pad(index + 1)} / ${pad(slides.length)}`;
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (slider.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;
      timer = window.setInterval(() => show(index + 1), Math.max(3, Number(slider.dataset.interval || 5)) * 1000);
    };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    slider.addEventListener('pointerdown', (e) => { pointerStart = e.clientX; }, { passive: true });
    slider.addEventListener('pointerup', (e) => {
      if (pointerStart === null) return;
      const delta = e.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) > 55) { show(index + (delta < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0); start();
  }

  function initOrderTracking(scope = document) {
    qa('[data-order-login-form]', scope).forEach((form) => {
      if (form.dataset.boundOrderLogin) return;
      form.dataset.boundOrderLogin = '1';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const base = form.dataset.loginUrl;
        if (!base) return;
        const email = q('input[type="email"]', form)?.value.trim() || '';
        try {
          const url = new URL(base, window.location.origin);
          if (email) url.searchParams.set('login_hint', email);
          window.location.assign(url.toString());
        } catch (e) { window.location.assign(base); }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => { qa('[data-password-drop-slider]').forEach(initDropSlider); initOrderTracking(); });
  document.addEventListener('shopify:section:load', (event) => { qa('[data-password-drop-slider]', event.target).forEach(initDropSlider); initOrderTracking(event.target); });
})();
